declare const pdfjsLib: any;
import { ComponentConstants, Events, eventsManager, TemplateImage } from "@rhinov/savane-js";
import { CustomController } from "../CustomController";
import { Entry } from "./Entry";
import { PlanManager, CocosConstants } from "@rhinov/cocos-plan";

declare const HP_CONFIG: any;

export class ImportModal {

    //#region Properties & Init
    static controller: CustomController;
    static onClose: (() => void) | undefined;
    static modalOpen: boolean;
    static deliverable: any;

    static isDesigner: boolean;
    static HtmlImage: HTMLImageElement | null = null;

    static backPlanUploaded: File | null = null;
    static fileClicked: boolean = false;
    static fileImported: File | undefined;
    static pdf: any | null = null;
    static PDF_LOW_RES_SCALE: number = 2.0;
    static PDF_HIGH_RES_SCALE: number = 3;
    static pdfScale: number = ImportModal.PDF_LOW_RES_SCALE;
    static rotate: number = 0;
    static currentPage: number = 0;

    static showDeliverableGallery: boolean = false;

    static zoom: number;
    static resizeListeners: ((...args: any[]) => any)[] = [];
    static processedPlan: any | null = null;
    static photosDeliverable: any;

    static realPropertyId: number;

    static removePhotoListeners: () => void = () => { };

    //#region Image Constants
    static LOADING_GIF: string = CocosConstants.resourcesBasePath + '/resources/loading.gif';
    static IMPORT_PLAN_IMG: string = CocosConstants.resourcesBasePath + '/resources/Import_Plan.png';
    static POINTER_IMG: string = CocosConstants.resourcesBasePath + '/resources/testcross.png';
    static TUTO_POINTER_IMG: string = CocosConstants.resourcesBasePath + '/resources/tutoLens.png';
    //#endregion

    //#region Pan Variables
    static buttonDownPlan: boolean = false;
    static dragging: boolean = false;
    static mousePosition: { x: number, y: number } | null = null;
    static landedMark: any[] = [];
    //#endregion

    //#region Drag&Drop Variables
    static draggedId: string | undefined;
    static backCopt: HTMLCanvasElement;

    static markerImage: HTMLImageElement = new Image();
    static markerImageLoaded: boolean = false;
    //#endregion

    static paperScale: Entry | null = null;
    static paperScales = [
        new Entry(20, '1/20'),
        new Entry(50, '1/50'),
        new Entry(75, '1/75'),
        new Entry(100, '1/100'),
        new Entry(125, '1/125'),
        new Entry(200, '1/200'),
    ];

    static paperFormat: Entry | null = null;
    static paperFormats = [
        new Entry(1, 'A0'),
        new Entry(2, 'A1'),
        new Entry(3, 'A2'),
        new Entry(4, 'A3'),
        new Entry(5, 'A4'),
    ];


    static init(deliverable: any, userData: { customers_groups_id: number; }, realPropertyId: number) {
        ImportModal.controller = new CustomController();
        ImportModal.isDesigner = userData && userData.customers_groups_id === 11;
        ImportModal.deliverable = deliverable;
        ImportModal.realPropertyId = realPropertyId;
        ImportModal.backCopt = document.createElement('canvas');
        ImportModal.markerImage = new Image();
        ImportModal.markerImage.onload = function () {
            ImportModal.markerImageLoaded = true;
        };
        ImportModal.markerImage.src = ImportModal.POINTER_IMG;
    }

    static reset() {
        ImportModal.controller.destroy();

        ImportModal.onClose = undefined;
        ImportModal.modalOpen = false;

        ImportModal.HtmlImage = null;

        ImportModal.backPlanUploaded = null;
        ImportModal.fileClicked = false;
        ImportModal.fileImported = undefined;

        ImportModal.showDeliverableGallery = false;

        ImportModal.zoom;
        ImportModal.resizeListeners.forEach((listener) => {
            window.removeEventListener('resize', listener);
        });
        ImportModal.resizeListeners = [];
        ImportModal.processedPlan = null;

        ImportModal.buttonDownPlan = false;
        ImportModal.dragging = false;
        ImportModal.mousePosition = null;
        ImportModal.landedMark = [];

        ImportModal.draggedId = undefined;
        ImportModal.backCopt = document.createElement('canvas');
        ImportModal.markerImageLoaded = false;
        ImportModal.markerImage = new Image();
        ImportModal.markerImage.onload = function () {
            ImportModal.markerImageLoaded = true;
        };
        ImportModal.markerImage.src = ImportModal.POINTER_IMG;

        ImportModal.paperFormat = null;
        ImportModal.paperScale = null;
    }

    static open(onClose: () => void) {
        if (ImportModal.controller === undefined) {
            console.error("You need to initialize the Modal before opening it !");
            return;
        }

        if (ImportModal.modalOpen) {
            if (ImportModal.onClose && typeof ImportModal.onClose === 'function') {
                ImportModal.close();
            } else {
                console.warn("Modal is open but onClose callback isn't properly set !");
            }
            ImportModal.reset();
            ImportModal.rotate = 0;
            ImportModal.pdf = null;
            ImportModal.PDF_LOW_RES_SCALE = 2.0;
            ImportModal.PDF_HIGH_RES_SCALE = 3;
            ImportModal.pdfScale = ImportModal.PDF_LOW_RES_SCALE;
            ImportModal.currentPage = 0;
        }

        ImportModal.onClose = onClose;
        $("#main-body").append(ImportModal.modal());
        ($('#importModal') as any).modal('show');
        setTimeout(() => {
            ImportModal.controller.addEventListener('click', ImportModal.close, 'importmodalcloser', undefined, true);
            ImportModal.controller.addEventListener(
                'click',
                (e) => { e.target.className === 'modal fade' && ImportModal.close() },
                'modal', undefined, true
            );
            ImportModal.modalOpen = true;
        }, 50);
    }

    static close() {
        var modal = document.getElementById('importModal');

        if (!modal) return;
        if (ImportModal.onClose && typeof ImportModal.onClose === 'function') {
            ImportModal.onClose();
        }
        ImportModal.reset();
        // The .modal method is only accesible via JQuery...
        ($('#importModal') as any).modal('hide');
        // Remove child takes a native HTMLElement...
        modal.remove();
    }

    static resizeWin() {
        if (ImportModal.HtmlImage !== null) {
            let width = $('#backgroundScrollView').width()
            if (width !== undefined) {
                ImportModal.zoom = width / ImportModal.HtmlImage.width;
            }

            if ($('#innerScrollContainer')) {
                $('#innerScrollContainer').width((ImportModal.zoom * ImportModal.HtmlImage.width));
                $('#innerScrollContainer').height(10000);
            }
            if ($('#backgroundImage')) {
                $('#backgroundImage').width(ImportModal.zoom * ImportModal.HtmlImage.width);
                $('#backgroundImage').height(ImportModal.zoom * ImportModal.HtmlImage.height);
            }
        }
        $('#backgroundScrollView').css('max-height', '90%');

    }
    //#endregion

    //#region Validation Methods

    static uploadedPlan(idPhoto: number, urlPlan: string, scale: number, rotate: number) {
        const planManager = PlanManager.getInstance();
        const floor = planManager.world?.currentScene?.currentFloor;
        if (!floor) return;

        var actualComponent = floor.getComponent(ComponentConstants.ComponentType.TemplateImage) as TemplateImage;
        if (actualComponent === null) {
            actualComponent = new TemplateImage(idPhoto, urlPlan, scale, rotate, [0, 0]) as TemplateImage;
            floor.addComponent(actualComponent);
        } else {
            //FIXME Maybe send an event here to handle deletion on server ?
            actualComponent.idPhoto = idPhoto;
            actualComponent.url = urlPlan;
            actualComponent.scale = scale;
            actualComponent.rotation = rotate;

            //TODO Delete current pricture from server ?
        }
        eventsManager.instance.dispatch(Events.BACK_PLAN_IMPORT, actualComponent);
        eventsManager.instance.dispatch(Events.PLAN_FLOOR_CHANGED, floor);
    }

    static sendPlan(zoom: number, screenDistance: number, realDistance: number) {
        //TODO If pdf reprocess page
        //Generate blob
        var elem = document.getElementById('backgroundImage');
        if (!elem) {
            console.error('Background image canvas not found !\n\tCancelling sendPlan method...');
            return;
        }
        var canvas = elem as HTMLCanvasElement;
        if (!HP_CONFIG.MEDIA_SERVER_TOKEN) {
            if (ImportModal.pdf !== null) {
                ImportModal.uploadedPlan(0, canvas.toDataURL('image/jpeg', 0.6), (realDistance * zoom) / (screenDistance), ImportModal.rotate);
            } else {
                ImportModal.uploadedPlan(0, canvas.toDataURL('image/jpeg', 0.6), (realDistance) / (screenDistance), ImportModal.rotate);
            }
        } else {
            canvas.toBlob((blob) => {
                if (!blob) {
                    console.error("Failed to get blob from canvas !");
                    return;
                }
                const scene = PlanManager.getInstance().world?.currentScene;
                const floor = scene?.currentFloor;
                if (!scene || !floor) return;
                var filename = 'plan_S' + scene.id + '_F' + floor.id + '_D' + ImportModal.deliverable.id + '.jpg';
                var path = ImportModal.realPropertyId + '/' + ImportModal.deliverable.id + '/plans/';
                var url = HP_CONFIG.MEDIA_SERVER_URI + 'pictures/deliverables/upload';
                var data = new FormData();
                data.append('logosfile', new File([blob], filename));
                data.append('path', path);
                fetch(url, {
                    method: 'POST',
                    headers: {
                        'APIKey': HP_CONFIG.MEDIA_SERVER_TOKEN,
                    },
                    body: data
                }).then(function (response) {
                    if (response.ok) {
                        response.json().then((data) => {
                            if (ImportModal.pdf !== null) {
                                ImportModal.uploadedPlan(0, data.url, (realDistance * zoom) / (screenDistance), ImportModal.rotate);
                            } else {
                                ImportModal.uploadedPlan(0, data.url, (realDistance) / (screenDistance), ImportModal.rotate);
                            }
                        });
                    }
                });
            }, 'image/jpeg', 0.6);
        }
        var element = $('#importmodalcloser');
        if (element) {
            element.click();
        }
    };

    static validateScale() {
        //Calculate distance pointers
        if (ImportModal.paperScale === null || ImportModal.paperFormat === null) {
            if (ImportModal.pdf !== null && ImportModal.pdfScale === ImportModal.PDF_HIGH_RES_SCALE) {
                ImportModal.loadPdfPage(ImportModal.currentPage, ImportModal.PDF_LOW_RES_SCALE);
            }
            if (ImportModal.landedMark.length !== 2) {
                eventsManager.instance.dispatch(Events.DISPLAY_ALERT, {
                    error: true,
                    message: 'Remplissez les champs de données d\'échelle ou placez les marqueurs'
                });
            }
            return;
        }
        var realWidth = 0;
        switch (ImportModal.paperFormat.id) {
            case 1:
                //A0
                realWidth = 841;
                break;
            case 2:
                //A1
                realWidth = 594;
                break;
            case 3:
                //A2
                realWidth = 420;
                break;
            case 4:
                //A3
                realWidth = 297;
                break;
            case 5:
                //A4
                realWidth = 210;
                break;
        }
        var realDistance = (realWidth * ImportModal.paperScale.id) / 10;
        var elem = document.getElementById('backgroundImage');

        if (!elem) {
            console.error("Background Image Canvas not found !");
            return;
        }

        var canvas = elem as HTMLCanvasElement;
        var screenDistance = canvas.width;
        if (canvas.height < canvas.width) {
            screenDistance = canvas.height;
        }
        //Set background to scene
        if (ImportModal.processedPlan === null) {
            ImportModal.sendPlan(1.0, screenDistance, realDistance);
        } else {
            var urlPlan = ImportModal.processedPlan.url;
            if (ImportModal.pdf !== null) {
                ImportModal.uploadedPlan(ImportModal.processedPlan.img, urlPlan, (realDistance * ImportModal.zoom) / (screenDistance), ImportModal.rotate);
            } else {
                ImportModal.uploadedPlan(ImportModal.processedPlan.img, urlPlan, (realDistance) / (screenDistance), ImportModal.rotate);
            }
            var element = $('#importmodalcloser');
            if (element) {
                element.click();
            }
            //close(textureToscene, 500);
        }
    };

    static validate() {
        if (ImportModal.pdf !== null && ImportModal.pdfScale === ImportModal.PDF_LOW_RES_SCALE) {
            ImportModal.loadPdfPage(ImportModal.currentPage, ImportModal.PDF_HIGH_RES_SCALE, ImportModal.validate);
            return;
        }
        //Calculate distance pointers
        var markerA = $('#markerA');
        var markerB = $('#markerB');
        var screenDistance = 0;
        if (ImportModal.landedMark.length === 2) {
            const offsetA = markerA.offset();
            const offsetB = markerB.offset();
            if (!offsetA || !offsetB) return;
            var distanceX = (offsetA.left - offsetB.left);
            var distanceY = (offsetA.top - offsetB.top);
            screenDistance = distanceX * distanceX + distanceY * distanceY;
            screenDistance = Math.sqrt(screenDistance);
            if (ImportModal.pdf !== null) {
                //Compensate resolution scaling for pdf
                screenDistance *= ImportModal.PDF_HIGH_RES_SCALE / ImportModal.PDF_LOW_RES_SCALE;
            }
        } else {
            if (ImportModal.pdf !== null && ImportModal.pdfScale === ImportModal.PDF_HIGH_RES_SCALE) {
                ImportModal.loadPdfPage(ImportModal.currentPage, ImportModal.PDF_LOW_RES_SCALE);
            }
            eventsManager.instance.dispatch(Events.DISPLAY_ALERT, {
                error: true,
                message: 'Les marqueurs n\'ont pas été placés sur le plan.'
            });
            ImportModal.validateScale();
            return;
        }

        var realDistance = parseInt($('#inputPlanScale').val() as string);
        if (realDistance === 0 || isNaN(realDistance)) {
            if (ImportModal.pdf !== null && ImportModal.pdfScale === ImportModal.PDF_HIGH_RES_SCALE) {
                ImportModal.loadPdfPage(ImportModal.currentPage, ImportModal.PDF_LOW_RES_SCALE);
            }
            if (ImportModal.paperScale === null || ImportModal.paperFormat === null) {
                eventsManager.instance.dispatch(Events.DISPLAY_ALERT, {
                    error: true,
                    message: 'La distance réelle entre les marqueurs n\'a pas été saisie.'
                });
            }

            ImportModal.validateScale();
            return;
        }
        //Set background to scene
        if (ImportModal.processedPlan === null) {
            ImportModal.sendPlan(ImportModal.zoom, screenDistance, realDistance);
        } else {
            var urlPlan = ImportModal.processedPlan.url;
            if (ImportModal.pdf !== null) {
                ImportModal.uploadedPlan(ImportModal.processedPlan.img, urlPlan, (realDistance * ImportModal.zoom) / (screenDistance), ImportModal.rotate);
            } else {
                // Here
                ImportModal.uploadedPlan(ImportModal.processedPlan.img, urlPlan, (realDistance) / (screenDistance), ImportModal.rotate);
            }
            var element = $('#importmodalcloser');
            if (element) {
                element.click();
            }
            //close(textureToscene, 500);
        }
    };
    //#endregion

    //#region File Related Methods

    //#region Misc. Methods
    static fileRelatedUpdates() {
        let scrollContainer = document.getElementById('innerScrollContainer');
        if (scrollContainer) {
            scrollContainer.style.display = ImportModal.HtmlImage === null ? 'none' : 'initial';
        }
        ImportModal.updateGeneric('buttonsPanelContainer', 'buttonsPanel');
        ImportModal.updateGeneric('planChoiceButton');
        ImportModal.updateGeneric('planChoiceProject');
        ImportModal.updateGeneric('fileInfo');
    }

    static handleFileSelect(f: File) {
        if (!f.type.match('image.*') && !f.type.match('pdf.*')) {
            eventsManager.instance.dispatch(Events.DISPLAY_ALERT, {
                error: true,
                message: 'Ce type de fichier n\'est pas pris en charge.'
            });
            return;
        }

        var elem = document.getElementById('backgroundImage');
        if (!elem) {
            console.error("Background Image Canvas not found !");
            return;
        }
        var canvas = elem as HTMLCanvasElement;
        canvas.height = 0;
        ImportModal.pdf = null;
        var r;
        if (f.type.match('image.*')) {
            r = new FileReader();
            r.onload = function (e: ProgressEvent<FileReader>) {
                if (!e.target?.result) return;
                ImportModal.HtmlImage = new Image();
                ImportModal.showDeliverableGallery = false;
                ImportModal.HtmlImage.crossOrigin = "anonymous";
                ImportModal.HtmlImage.onload = function () {
                    if (!ImportModal.HtmlImage) return;
                    //Image loaded, create cocos texture
                    var elem = document.getElementById('backgroundImage');
                    if (!elem) {
                        console.error("Background Image Canvas not found !");
                        return;
                    }
                    var canvas = elem as HTMLCanvasElement;
                    canvas.height = ImportModal.HtmlImage.height;
                    canvas.width = ImportModal.HtmlImage.width;

                    ImportModal.resizeWin();
                    canvas.width = ImportModal.zoom * ImportModal.HtmlImage.width;
                    canvas.height = ImportModal.zoom * ImportModal.HtmlImage.height;
                    ImportModal.resizeListeners.push(function () {
                        ImportModal.resizeWin();
                        if (!ImportModal.HtmlImage) return;
                        canvas.width = ImportModal.zoom * ImportModal.HtmlImage.width;
                        canvas.height = ImportModal.zoom * ImportModal.HtmlImage.height;
                        var context = canvas.getContext('2d');
                        if (!context) {
                            console.error("Failed to find 2D context on canvas !");
                            return;
                        }
                        context.drawImage(ImportModal.HtmlImage, 0, 0, canvas.width, canvas.height);
                    });
                    const lastListener = ImportModal.resizeListeners.at(-1);
                    if (lastListener !== undefined) {
                        window.addEventListener('resize', lastListener);
                    }
                    var context = canvas.getContext('2d');
                    if (!context) {
                        console.error("Failed to find 2D context on canvas !");
                        return;
                    }
                    context.drawImage(ImportModal.HtmlImage, 0, 0, canvas.width, canvas.height);

                    ImportModal.fileRelatedUpdates();
                    ImportModal.updateGeneric('markersContainer', 'markers');
                };

                $('#backgroundScrollView').removeClass('imageLoader');
                ImportModal.processedPlan = null;
                if (e.target && typeof e.target.result === 'string') {
                    ImportModal.HtmlImage.src = e.target.result;
                }
                ImportModal.rotate = 0;
            };
            r.readAsDataURL(f);
        } else {
            r = new FileReader();
            r.onload = function (_e) {
                if (!(this.result instanceof ArrayBuffer)) return;
                var typedarray = new Uint8Array(this.result);
                pdfjsLib.getDocument(typedarray).promise.then(function (pdf: any) {
                    if (ImportModal.pdf) {
                        ImportModal.pdf.destroy();
                    }
                    ImportModal.pdf = pdf;
                    ImportModal.currentPage = 1;
                    ImportModal.rotate = 0;
                    ImportModal.loadPdfPage(ImportModal.currentPage, ImportModal.PDF_LOW_RES_SCALE);
                });
            };
            r.readAsArrayBuffer(f);
        }
        $('#backgroundScrollView').addClass('imageLoader');
    };

    static importPlanForRhinov() {
        if (!ImportModal.fileClicked) {
            ImportModal.fileClicked = true;
            const backPlan = document.getElementById('back-plan-rhinov-pick');
            if (backPlan !== null) {
                backPlan.click();
            }
            ImportModal.fileClicked = false;
        }
    }

    static showGallery() {
        ImportModal.showDeliverableGallery = true;
        ImportModal.photosDeliverable = ImportModal.deliverable.photos_deliverables;
        ImportModal.updatePlanChoice();
    };

    static setBackPlanUploaded(newValue: File) {
        ImportModal.backPlanUploaded = newValue;
        ImportModal.fileClicked = false;
        if (newValue && newValue !== null) {
            if (newValue.type.indexOf('image') > -1 || newValue.type.indexOf('pdf') > -1) {
                ImportModal.setFileImported(newValue);
            } else {
                eventsManager.instance.dispatch(Events.DISPLAY_ALERT, {
                    error: true,
                    message: 'Type de fichier incompatible'
                });
            }
        }
    }

    static setFileImported(newValue: File) {
        if (newValue !== null && newValue !== undefined) {
            ImportModal.handleFileSelect(newValue);
            ImportModal.fileImported = newValue;
        }
    };

    static createFileFromUrl(url: string, filename: string = "") {
        fetch(url).then((response) => {
            try {
                response.blob().then((blob) => {
                    var file = new File([blob], filename, { type: blob.type });
                    ImportModal.setFileImported(file);
                })
            } catch (ex) {
                console.error(ex);
                ImportModal.showDeliverableGallery = false;
            }
        });
    };
    //#endregion

    //#region PDF Methods

    static loadPdfPage(index: number, scale: number, callback?: (img: HTMLImageElement | null) => any) {
        if (!ImportModal.pdf) {
            console.warn("No pdf loaded !");
            return;
        }
        ImportModal.pdfScale = scale;
        ImportModal.pdf.getPage(index).then(function (page: any) {
            var viewport = page.getViewport({ scale: scale });
            $('#backgroundImage').hide();
            var elem = document.getElementById('backgroundImage');
            if (!elem) {
                console.error("Background Image Canvas not found !");
                return;
            }
            var canvas = elem as HTMLCanvasElement;
            var context = canvas.getContext('2d');
            if (!context) {
                console.error("Failed to find 2D context on canvas !");
                return;
            }
            canvas.height = viewport.height;
            canvas.width = viewport.width;

            var renderContext = {
                canvasContext: context,
                viewport: viewport
            };
            page.render(renderContext).promise.then(function (_param: any) {
                ImportModal.HtmlImage = new Image();
                ImportModal.showDeliverableGallery = false;
                ImportModal.HtmlImage.crossOrigin = "anonymous";
                ImportModal.HtmlImage.onload = function () {
                    if (callback !== undefined) {
                        callback(ImportModal.HtmlImage);
                    }

                    if (ImportModal.HtmlImage === null) return;

                    //Image loaded, create cocos texture
                    $('#backgroundImage').show();
                    ImportModal.processedPlan = null;
                    ImportModal.resizeWin();

                    ImportModal.resizeListeners.push(ImportModal.resizeWin);
                    const lastListener = ImportModal.resizeListeners.at(-1);
                    if (lastListener !== undefined) {
                        window.addEventListener('resize', lastListener);
                    }
                };
                ImportModal.HtmlImage.src = canvas.toDataURL('image/jpeg', 0.6);
                $('#backgroundScrollView').removeClass('imageLoader');
                ImportModal.fileRelatedUpdates();
                if (callback === undefined) {
                    ImportModal.updateGeneric('markersContainer', 'markers');
                }
            });
        });
    };

    static nextPage() {
        if (ImportModal.pdf !== null) {
            ImportModal.currentPage++;
            if (ImportModal.currentPage > ImportModal.pdf._pdfInfo.numPages) {
                ImportModal.currentPage = 1;
            }
            ImportModal.rotate = 0;
            ImportModal.loadPdfPage(ImportModal.currentPage, ImportModal.PDF_LOW_RES_SCALE);
        }
    };

    static previousPage() {
        if (ImportModal.pdf !== null) {
            ImportModal.currentPage--;
            if (ImportModal.currentPage <= 0) {
                ImportModal.currentPage = ImportModal.pdf._pdfInfo.numPages;
            }
            ImportModal.rotate = 0;
            ImportModal.loadPdfPage(ImportModal.currentPage, ImportModal.PDF_LOW_RES_SCALE);
        }
    };

    //#region Rotation Methods
    static processRotation() {
        $('#backgroundImage').css('-ms-transform', 'rotate(' + ImportModal.rotate + 'deg)'); //IE9
        $('#backgroundImage').css('-webkit-transform', 'rotate(' + ImportModal.rotate + 'deg)'); //Chrome,Safari,Opera
        $('#backgroundImage').css('transform', 'rotate(' + ImportModal.rotate + 'deg)');
    };

    static rotateLeft(_evt: Event) {
        ImportModal.rotate -= 0.15;
        ImportModal.processRotation();
    };

    static rotateLeft10(_evt: Event) {
        ImportModal.rotate -= 2.1;
        ImportModal.processRotation();
    };

    static rotateRight(_evt: Event) {
        ImportModal.rotate += 0.15;
        ImportModal.processRotation();
    };

    static rotateRight10(_evt: Event) {
        ImportModal.rotate += 2.1;
        ImportModal.processRotation();
    };

    static flip(_evt: Event) {
        ImportModal.rotate += 90;
        ImportModal.processRotation();
    };
    //#endregion

    //#endregion

    //#endregion

    //#region Listeners

    //#region fileInfo

    static fileInfoListeners() {

        if ($('#back-plan-rhinov-pick')[0]) {
            ImportModal.controller.addEventListener('change', (evt) => {
                const file = evt.target.files[0];
                ImportModal.setBackPlanUploaded(file);
            }, "back-plan-rhinov-pick", undefined, true);
        }

        if ($('#returnToStepOne')[0]) {
            ImportModal.controller.addEventListener('click', (_evt) => {
                if (ImportModal.isDesigner) {
                    ImportModal.HtmlImage = null;
                    ImportModal.fileRelatedUpdates();
                    ImportModal.updateGeneric('markersContainer', 'markers');

                } else {
                    ImportModal.importPlanForRhinov();
                }
            }, "returnToStepOne");
        }
    }

    static removeFileInfoListeners() {
        if ($('#back-plan-rhinov-pick')[0]) {
            ImportModal.controller.removeEventListener('change', "back-plan-rhinov-pick");
        }

        if ($('#returnToStepOne')[0]) {
            ImportModal.controller.removeEventListener('click', "returnToStepOne");
        }
    }

    //#endregion

    //#region planChoice

    static removePlanChoiceButtonListeners() {

        if ($('#genericImportBtn')[0]) {
            ImportModal.controller.removeEventListener('click', "genericImportBtn");
        }

        if ($("#planImportDialog")[0]) {

            ImportModal.controller.removeEventListener('click', "importFromPC");
            ImportModal.controller.removeEventListener('click', "importFromProject");
        }
    }

    static planChoiceButtonListeners() {

        if ($('#genericImportBtn')[0]) {
            ImportModal.controller.addEventListener('click', (_evt) => {
                ImportModal.importPlanForRhinov();
            }, "genericImportBtn");
        }

        if ($("#planImportDialog")[0]) {

            ImportModal.controller.addEventListener('click', (_evt) => {
                ImportModal.importPlanForRhinov();
            }, "importFromPC");

            ImportModal.controller.addEventListener('click', (_evt) => {
                ImportModal.showGallery();
            }, "importFromProject");
        }
    }

    static removePlanChoiceProjectListeners() {

        if ($('.back')[0]) {
            ImportModal.controller.removeEventListener('click', "back", '0');

            ImportModal.removePhotoListeners();
        }
    }

    static planChoiceProjectListeners() {

        if ($(".back")[0]) {
            ImportModal.controller.addEventListener('click', (_evt) => {
                ImportModal.showDeliverableGallery = false;
                ImportModal.updatePlanChoice();
            }, "back", "0");
        }
    }

    //#endregion

    //#region backgroundScrollView
    static backgroundScrollViewListeners() {

        if ($("#backgroundScrollView")[0]) {
            ImportModal.controller.addEventListener('mousemove', ImportModal.mouseMovePlan, "backgroundScrollView", undefined, true);
            ImportModal.controller.addEventListener('mousedown', ImportModal.mouseDownPlan, "backgroundScrollView", undefined, true);
            ImportModal.controller.addEventListener('mouseleave', ImportModal.mouseUpLeavePlan, "backgroundScrollView", undefined, true);
            ImportModal.controller.addEventListener('mouseup', ImportModal.mouseUpLeavePlan, "backgroundScrollView", undefined, true);
        }

        if ($("#innerScrollContainer")[0]) {
            $("#innerScrollContainer").droppable({
                drop: ImportModal.onDropPlan,
                over: ImportModal.onDragIn,
                out: ImportModal.onDragOut
            });
        }
    }

    static removeBackgroundScrollViewListeners() {
        if (ImportModal.HtmlImage !== null) {
            if ($("#backgroundScrollView")[0]) {
                ImportModal.controller.removeEventListener('mousemove', "backgroundScrollView", undefined, true);
                ImportModal.controller.removeEventListener('mousedown', "backgroundScrollView", undefined, true);
                ImportModal.controller.removeEventListener('mouseleave', "backgroundScrollView", undefined, true);
                ImportModal.controller.removeEventListener('mouseup', "backgroundScrollView", undefined, true);
            }

            if ($("#innerScrollContainer")[0]) {
                $("#innerScrollContainer").droppable('destroy');
            }
        }
    }
    //#endregion

    //#region buttonsPanel
    static buttonsPanelListeners() {
        if ($("#buttonsPanel")) {
            $("#buttonsPanel").droppable();

            ImportModal.controller.addEventListener('click', ImportModal.rotateLeft, "rotateLeft", undefined, true);
            ImportModal.controller.addEventListener('click', ImportModal.rotateLeft10, "rotateLeft10", undefined, true);

            ImportModal.controller.addEventListener('click', ImportModal.rotateRight, "rotateRight", undefined, true);
            ImportModal.controller.addEventListener('click', ImportModal.rotateRight10, "rotateRight10", undefined, true);

            ImportModal.controller.addEventListener('click', ImportModal.flip, "flip", undefined, true);

            ImportModal.controller.addEventListener('click', ImportModal.previousPage, "leftArrowButton", undefined, true);
            ImportModal.controller.addEventListener('click', ImportModal.nextPage, "rightArrowButton", undefined, true);
        }
    }

    static removeButtonsPanelListeners() {
        if ($("#buttonsPanel")) {
            $("#buttonsPanel").droppable('destroy');

            ImportModal.controller.removeEventListener('click', "rotateLeft");
            ImportModal.controller.removeEventListener('click', "rotateLeft10");

            ImportModal.controller.removeEventListener('click', "rotateRight");
            ImportModal.controller.removeEventListener('click', "rotateRight10");

            ImportModal.controller.removeEventListener('click', "flip");

            ImportModal.controller.removeEventListener('click', "leftArrowButton");
            ImportModal.controller.removeEventListener('click', "rightArrowButton");
        }
    }
    //#endregion

    //#region markers
    static markersListeners() {
        if ($("#markers")) {
            $("#markers").droppable();

            let dragOptions: JQueryUI.DraggableOptions = {
                revert: 'invalid',
                containment: '#backgroundScrollView',
                drag: ImportModal.onDragOver,
                start: ImportModal.startDrag,
                stop: ImportModal.stopDrag,
            }

            $('#markerA').draggable(dragOptions);

            $('#markerB').draggable(dragOptions);
        }
    }

    static removeMarkersListeners() {
        $("#markers").droppable('destroy');

        $('#markerA').draggable('destroy');
        $('#markerB').draggable('destroy');
    }
    //#endregion

    //#region stageThreeBis
    static stageThreeBisListeners() {

        if ($("#paperFormat")) {
            ImportModal.controller.addEventListener('change', (evt) => { ImportModal.paperChangeListener(evt, 'format') },
                'paperFormat', undefined, true);
        };

        if ($("#paperScale")) {
            ImportModal.controller.addEventListener('change', (evt) => { ImportModal.paperChangeListener(evt, 'scale') },
                'paperScale', undefined, true);
        };
    }

    static removeStageThreeBisListeners() {
        ImportModal.controller.removeEventListener('change', 'paperFormat');
        ImportModal.controller.removeEventListener('change', 'paperScale');
    }
    //#endregion

    //#endregion

    /**
     * 
     * @param {InputEvent} evt 
     * @param {"format" | "scale"} type 
     */
    static paperChangeListener(evt: InputEvent, type: "format" | "scale") {
        const input = evt.target as HTMLSelectElement;
        const cap = type[0].toUpperCase() + type.slice(1);
        const name = `paper${cap}` as "paperFormat" | "paperScale";
        const namesPlural = `${name}s` as "paperFormats" | "paperScales";
        if (input.selectedIndex <= 0) {
            (ImportModal as any)[name] = null;
        };

        if (input.selectedIndex > (ImportModal as any)[namesPlural].length) {
            console.error("Cannot selected an index higher than the list length...");
            return;
        };

        (ImportModal as any)[name] = (ImportModal as any)[namesPlural].at(input.selectedIndex - 1);
    }

    //#region Updaters

    static updatePlanChoice() {
        ImportModal.updateGeneric('planChoiceButton');
        ImportModal.updateGeneric('planChoiceProject');
    }

    static updateGeneric(containerId: string, funcName?: string) {

        const container = document.getElementById(containerId);

        if (container === null) {
            console.error(`Can't find element with id '${containerId}' !`);
            return;
        }
        let name = funcName || containerId;
        let cap = name.toUpperCase()[0] + name.slice(1);
        let remove = (ImportModal as any)[`remove${cap}Listeners`];
        if (!remove || typeof remove !== 'function') {
            console.error(`No methods named 'remove${cap}Listeners' found !`);
            return;
        };
        remove();

        let html = (ImportModal as any)[`${name}Html`];
        if (!html || typeof html !== "function") {
            console.error(`No methods named '${name}Html' found !`);
            return;
        };
        container.innerHTML = html();
    }

    //#endregion

    //#region JQuery UI Drop events

    //#region Droppable (ie. Markers)

    static startDrag(_evt: Event, _ui: { helper: any, position: any, offset: any }) {
        ImportModal.dragging = true;
    };

    static stopDrag = function () {
        if (!ImportModal.draggedId) return;
        ImportModal.dragging = false;
        var draggedItem = document.getElementById(ImportModal.draggedId);
        if (draggedItem === null) {
            return;
        }
        draggedItem.style.visibility = 'visible';
    };

    static onDragOver(_event: Event, ui: { helper: any, position: any, offset: any }) {
        if (!ImportModal.draggedId) return;
        var desiredZoom = 3;
        var desiredMarkerzoom = 3;

        var elem = document.getElementById(ImportModal.draggedId);
        if (elem === null) {
            return;
        }
        var draggedItem = elem as HTMLImageElement;
        draggedItem.style.visibility = 'hidden';
        var elem = document.getElementById('zoomLens');

        if (!elem) {
            console.error("Can't find zoomLens !");
            return;
        }
        var zoomLens = elem as HTMLCanvasElement;

        // Size of the final markers
        zoomLens.width = 100 * desiredMarkerzoom;
        zoomLens.height = 100 * desiredMarkerzoom;

        zoomLens.style.width = zoomLens.width + 'px';
        zoomLens.style.height = zoomLens.height + 'px';
        $('#backgroundImage').css('-ms-transform', 'rotate(0deg)'); //IE9
        $('#backgroundImage').css('-webkit-transform', 'rotate(0deg)'); //Chrome,Safari,Opera
        $('#backgroundImage').css('transform', 'rotate(0deg)');
        var elem = document.getElementById('backgroundImage');
        if (!elem) {
            console.error("Background Image Canvas not found !");
            return;
        }
        var back = elem as HTMLCanvasElement;
        ImportModal.backCopt.width = back.width;
        ImportModal.backCopt.height = back.height;
        var copyCtx = ImportModal.backCopt.getContext('2d');

        if (!copyCtx) {
            console.error("Can't get 2D context of backCopt canvas !");
            return;
        }

        copyCtx.translate(back.width * 0.5, back.height * 0.5);
        copyCtx.rotate(ImportModal.rotate * Math.PI / 180);
        copyCtx.translate(-back.width * 0.5, -back.height * 0.5);
        copyCtx.drawImage(back, 0, 0, back.width, back.height);

        var ctx = zoomLens.getContext('2d');
        if (!ctx) {
            console.error("Can't get 2D context of backgroundImage canvas !");
            return;
        }
        ctx.clearRect(0, 0, zoomLens.width, zoomLens.height);
        //ctx.fillRect(0,0,zoomLens.width,zoomLens.height);
        //Retrieve positin within div
        var offset = $('#backgroundImage').offset();
        var yPos, xPos;
        if (!offset) {
            console.warn("Can't get offset of backgroundImage !");
            [yPos, xPos] = [0, 0];
        } else {
            yPos = ui.offset.top - offset.top;
            xPos = ui.offset.left - offset.left;
        }

        var lensWidth = zoomLens.width * 0.5;
        var diff = zoomLens.width - lensWidth;
        ctx.shadowBlur = 20;
        ctx.shadowColor = 'black';
        ctx.fillStyle = '#FBE800';
        ctx.save();
        if (!ImportModal.markerImageLoaded) {
            ctx.beginPath();
            ctx.arc(zoomLens.width * 0.5, zoomLens.height * 0.5, lensWidth * 0.5, 0, 2 * Math.PI);
            ctx.fill();
            ctx.closePath();

            ctx.fillStyle = 'white';
            ctx.beginPath();
            ctx.arc(zoomLens.width * 0.5, zoomLens.height * 0.5, lensWidth * 0.45, 0, Math.PI * 2, true); // you can use any shape
            // ctx.clip();
        } else {
            ctx.beginPath();
            ctx.arc(zoomLens.width * 0.5, zoomLens.height * 0.5, Math.round(lensWidth * 0.43), 0, 2 * Math.PI);
        }
        ctx.clip();

        // Final coordinates for the bitmap drawImage below
        var destPosX, destPosY, destWidth, destHeight, srcPosX, srcPosY, srcWidth, srcHeight;

        if (ImportModal.pdf === null) {
            // Source position and size for the drawImage below
            srcPosX = xPos - (zoomLens.width * (1 / desiredZoom)) + (draggedItem.width * 0.5) + (diff * (1 / desiredZoom));
            srcPosY = yPos - (zoomLens.height * (1 / desiredZoom)) + (draggedItem.height * 0.5) + (diff * (1 / desiredZoom));
            srcWidth = zoomLens.width / desiredZoom;
            srcHeight = zoomLens.height / desiredZoom;

            // Destination Width and height
            destWidth = zoomLens.width;
            destHeight = zoomLens.height;
            // Destination position
            destPosX = 0;
            destPosY = 0;

            // Are we out of the source bitmap (left) ?
            if (srcPosX < 0) {
                // Adjust dest X and width and source X and width
                destPosX -= (srcPosX * desiredZoom);
                destWidth -= destPosX;
                srcWidth += srcPosX;
                srcPosX = 0;
            }
            // Are we out of the source bitmap (up) ?
            if (srcPosY < 0) {
                // Adjust dest Y and height and source Y and height
                destPosY -= (srcPosY * desiredZoom);
                destHeight -= destPosY;
                srcHeight += srcPosY;
                srcPosY = 0;
            }
            // If anything to copy (width and height > 0)
            if (destWidth > 0 && destHeight > 0) {
                // Display zoomed image behind the marker
                ctx.drawImage(ImportModal.backCopt, srcPosX, srcPosY, srcWidth, srcHeight, destPosX, destPosY, destWidth, destHeight);
            }
        } else {
            // Source position and size for the drawImage below
            srcPosX = (xPos - (zoomLens.width * (1 / desiredZoom)) + (draggedItem.width * 0.5) + (diff * (1 / desiredZoom))) / ImportModal.zoom;
            srcPosY = (yPos - (zoomLens.height * (1 / desiredZoom)) + (draggedItem.height * 0.5) + (diff * (1 / desiredZoom))) / ImportModal.zoom;
            srcWidth = (zoomLens.width / desiredZoom) / ImportModal.zoom;
            srcHeight = (zoomLens.height / desiredZoom) / ImportModal.zoom;

            // Destination Width and height
            destWidth = zoomLens.width;
            destHeight = zoomLens.height;
            // Destination position
            destPosX = 0;
            destPosY = 0;

            // Are we out of the source bitmap (left) ?
            if (srcPosX < 0) {
                // Adjust dest X and width and source X and width
                destPosX -= (srcPosX * desiredZoom) * ImportModal.zoom;
                destWidth -= destPosX;
                srcWidth += srcPosX;
                srcPosX = 0;
            }
            // Are we out of the source bitmap (up) ?
            if (srcPosY < 0) {
                // Adjust dest Y and height and source Y and height
                destPosY -= (srcPosY * desiredZoom) * ImportModal.zoom;
                destHeight -= destPosY;
                srcHeight += srcPosY;
                srcPosY = 0;
            }

            if (destWidth > 0 && destHeight > 0) {
                // Display zoomed image behind the marker
                ctx.drawImage(ImportModal.backCopt, srcPosX, srcPosY, srcWidth, srcHeight, destPosX, destPosY, destWidth, destHeight);
            }
        }

        ctx.restore();
        // Display the zoomed marker
        if (ImportModal.markerImageLoaded) {
            ctx.drawImage(ImportModal.markerImage, zoomLens.width * 0.2, zoomLens.height * 0.2, zoomLens.width * 0.6, zoomLens.height * 0.6);
        }
        ctx.closePath();
        //Retrieve positin within div
        let backOffset = $('#backgroundScrollView').offset();
        let top, left;

        if (!backOffset) {
            console.warn("Can't get offset of BackgroundScrollView !");
            [top, left] = [0, 0];
        } else {
            [top, left] = [backOffset.top, backOffset.left];
        }
        zoomLens.style.top = ui.offset.top - top - zoomLens.height * 0.5 + draggedItem.height * 0.5 + 'px';
        zoomLens.style.left = ui.offset.left - left - zoomLens.width * 0.5 + draggedItem.width * 0.5 + 'px';
        $('#backgroundImage').css('-ms-transform', 'rotate(' + ImportModal.rotate + 'deg)'); //IE9
        $('#backgroundImage').css('-webkit-transform', 'rotate(' + ImportModal.rotate + 'deg)'); //Chrome,Safari,Opera
        $('#backgroundImage').css('transform', 'rotate(' + ImportModal.rotate + 'deg)');
    };

    //#endregion

    //#region Dropzones
    /**
     * Callback fired when a marker has been dropped on the plan
     */
    static onDropPlan(_evt: Event, ui: { draggable: any, helper: any, position: any, offset: any }) {
        if (!ImportModal.draggedId) return;
        var draggedItem = document.getElementById(ImportModal.draggedId);
        if (draggedItem === null) {
            return;
        }
        draggedItem.style.visibility = 'visible';
        var zoomLens = document.getElementById('zoomLens');
        if (!zoomLens) {
            console.error("Can't find zoomLens");
            return;
        }
        var indexOf = ImportModal.landedMark.indexOf(ui.draggable.attr('id'));
        if (indexOf < 0) {
            ImportModal.landedMark.push(ui.draggable.attr('id'));
        }
        zoomLens.style.display = 'none';
    };

    static onDragIn(evt: Event) {
        const target = evt.currentTarget as HTMLElement;
        if (target.id !== undefined) {
            ImportModal.draggedId = target.id;
        }
        var zoomLens = document.getElementById('zoomLens');
        if (!zoomLens) {
            console.error("Can't find zoomLens");
            return;
        }
        zoomLens.style.display = 'block';
    };

    static onDragOut() {
        if (!ImportModal.draggedId) return;
        var draggedItem = document.getElementById(ImportModal.draggedId);
        if (draggedItem === null) {
            return;
        }
        draggedItem.style.visibility = 'visible';
        var zoomLens = document.getElementById('zoomLens');
        if (!zoomLens) {
            console.error("Can't find zoomLens");
            return;
        }
        zoomLens.style.display = 'none';
    };
    //#endregion

    //#endregion

    //#region Mouse Pan

    static mouseMovePlan(event: MouseEvent) {
        if (!ImportModal.buttonDownPlan || ImportModal.dragging) return;
        if (!ImportModal.HtmlImage) return;

        if (ImportModal.mousePosition === null) {
            ImportModal.mousePosition = {
                x: event.clientX,
                y: event.clientY
            };
        } else {
            ImportModal.moveWithOffset(event.clientX - ImportModal.mousePosition.x, event.clientY - ImportModal.mousePosition.y);
            ImportModal.mousePosition = {
                x: event.clientX,
                y: event.clientY
            };
        }
    };

    static calculateFinalPos(pos: number, imagePos: number, containerPos: number, posDiff: number, margin: number = 0) {
        let finalPos = pos + posDiff;

        const posLimit = (imagePos + margin - containerPos);

        if (finalPos < 0) {
            if (finalPos < -posLimit) {
                finalPos = -posLimit;
            }
        } else if (finalPos > 0) {
            if (finalPos > margin) {
                finalPos = margin;
            }
        }

        posDiff = finalPos - pos;
        if (posDiff !== 0) {
            posDiff = posDiff;
        }
        if (Math.abs(posDiff) >= 0 && Math.abs(posDiff) < 1) {
            posDiff = 0;
        };
        return [posDiff, finalPos];
    }

    static moveWithOffset(diffX: number, diffY: number) {
        let backgroundImage = $('#backgroundImage');
        let backgroundScrollView = $('#backgroundScrollView');
        let innerScrollContainer = $('#innerScrollContainer');

        let backWidth = backgroundImage.width();
        let scrollWidth = backgroundScrollView.width();

        if (!backWidth || !scrollWidth) {
            console.error("Can't get scrollWidth or backgroundImageWidth !");
            return;
        }

        let backHeight = backgroundImage.height();
        let scrollHeight = backgroundScrollView.height();

        if (!backHeight || !scrollHeight) {
            console.error("Can't get scrollHeight or backgroundImageHeight !");
            return;
        }


        const rotate = Math.abs(ImportModal.rotate % 360);

        const yMargin = 400;
        const xMargin = 300;
        // Start is the base case
        if (rotate === 0 || rotate === 180) {
            // X Axis
            if (backWidth > scrollWidth) {
                var currentPosX = parseInt(innerScrollContainer.css('left').replace('px', ''));
                let finalPosX: number;
                [diffX, finalPosX] = ImportModal.calculateFinalPos(currentPosX, backWidth, scrollWidth, diffY);
                innerScrollContainer.css('left', finalPosX + 'px');

            } else {
                diffX = 0;
                innerScrollContainer.css('left', 0 + 'px');
            }

            // Y Axis
            if (backHeight > scrollHeight) {
                let currentPosY = parseInt(innerScrollContainer.css('top').replace('px', ''));
                let finalPosY: number;
                [diffY, finalPosY] = ImportModal.calculateFinalPos(currentPosY, backHeight, scrollHeight, diffY);

                innerScrollContainer.css('top', finalPosY + 'px');
            } else {
                diffY = 0;
                innerScrollContainer.css('top', '0px');
            }
        } else {

            // X Axis
            if (backWidth + xMargin > scrollWidth) {
                var currentPosX = parseInt(innerScrollContainer.css('left').replace('px', ''));
                let finalPosX: number;
                [diffX, finalPosX] = ImportModal.calculateFinalPos(currentPosX, backWidth, scrollWidth, diffX, xMargin);
                innerScrollContainer.css('left', finalPosX + 'px');

            } else {
                diffX = 0;
                innerScrollContainer.css('left', 0 + 'px');
            }

            // Y Axis
            if (backHeight + yMargin > scrollHeight) {
                let currentPosY = parseInt(innerScrollContainer.css('top').replace('px', ''));
                let finalPosY: number;
                [diffY, finalPosY] = ImportModal.calculateFinalPos(currentPosY, backHeight, scrollHeight, diffY, yMargin);

                innerScrollContainer.css('top', finalPosY + 'px');
            } else {
                diffY = 0;
                innerScrollContainer.css('top', '0px');
            }
        }

        for (var i = 0; i < ImportModal.landedMark.length; i++) {
            var marker = $('#' + ImportModal.landedMark[i]);
            var newMarkerPosY = parseFloat(marker.css('top').replace('px', '')) + diffY;
            marker.css('top', newMarkerPosY + 'px');

            var newMarkerPosX = parseFloat(marker.css('left').replace('px', '')) + diffX;
            marker.css('left', newMarkerPosX + 'px');
        }
    };

    static mouseUpLeavePlan(_event: MouseEvent) {
        ImportModal.buttonDownPlan = false;
    };

    static mouseDownPlan(event: MouseEvent) {
        ImportModal.buttonDownPlan = true;
        ImportModal.mousePosition = {
            x: event.clientX,
            y: event.clientY
        };
    };

    //#endregion

    //#region HTML

    static fileInfoHtml() {
        setTimeout(() => {
            ImportModal.fileInfoListeners();
        }, 50);
        return `
        <input type="file" id="back-plan-rhinov-pick" style="display:none" accept=".jpg,.jpeg,.png,.JPG,.JPEG,.pdf" />
        <h3 style="text-align:center;margin-top:0px;margin-bottom:0px${ImportModal.HtmlImage === null ? ';display:none' : ''}">${ImportModal.HtmlImage !== null && ImportModal.fileImported ? ImportModal.fileImported.name : ''}
            <a href="javascript:void(0)" id="returnToStepOne" class="btn btn-link">
                <i class="material-icons icon-Input" style="font-size:200%;"></i>
            </a>
        </h3>
        `;
    }

    static planChoiceButtonHtml() {
        setTimeout(() => {
            ImportModal.planChoiceButtonListeners();
        }, 200);
        return `
        <div class="plan-choice-button vertical-container" 
        ${ImportModal.HtmlImage !== null || ImportModal.showDeliverableGallery ? 'style="display:none"' : ''}>
            <h3 style="font-weight:700;">Étape 1</h3>
            <img src="${ImportModal.IMPORT_PLAN_IMG}" />
            <h3>Importer un plan</h3>
            <p class="caption">
                <span>Fichiers compatibles:</span><br>
                <b>.pdf</b>,<b>.jpg</b> et <b>.png</b>
            </p>
            <!-- TODO: Remove since it doesn't look used anymore... -->
            ${!ImportModal.isDesigner || !ImportModal.deliverable.photos_deliverables || ImportModal.deliverable.photos_deliverables.length === 0 ? `
            <div>
                <button id="genericImportBtn" class="btn btn-primary btn-lg">
                    <span>Importer</span><i class="material-icons icon-FermerInactive"></i>
                </button>
            </div>
            `: `
            <div id="planImportDialog">
                <button id="importFromPC" class="btn btn-primary btn-lg">
                    <span>Depuis mon PC</span><i class="material-icons icon-FermerInactive"></i>
                </button>
                <button id="importFromProject" style="display:block;margin-top:10px;" class="btn btn-primary btn-lg">
                    <span>Depuis le projet</span><i class="material-icons icon-FermerInactive"></i>
                </button>
            </div>
            `}
        </div>
        `;
    }

    static planChoiceProjectHtml() {
        if (!ImportModal.deliverable.photos_deliverables) return '';
        setTimeout(() => {
            ImportModal.planChoiceProjectListeners();
        }, 50);

        let photosHtml = '';
        let photoIds: string[] = [];

        for (let i = 0; i < ImportModal.deliverable.photos_deliverables.length; i++) {
            let p = ImportModal.deliverable.photos_deliverables[i];

            const id = `deliverable_${p.id}_${p.filename}`;
            photosHtml += `
            <div id="${id}">
            ${p.filename.indexOf('.pdf') !== -1 ? `
                <span>${p.filename}</span>
            `: `
                <img src="${p.path}${p.filename}" alt="${p.id}">
            `}
            </div>
            `;
            photoIds.push(id);

            setTimeout(() => {
                let f = ImportModal.createFileFromUrl.bind(this, p.path + p.filename, p.filename);
                ImportModal.controller.addEventListener('click', f, id);
            }, 100);
        }

        ImportModal.removePhotoListeners = () => {
            photoIds.forEach((pId) => {
                ImportModal.controller.removeEventListener('click', pId);
            });
        };

        return `
        <div class="plan-choice-from-project" ${ImportModal.HtmlImage !== null || !ImportModal.showDeliverableGallery ? 'style="display:none"' : ''}>
            <span class="back">Retour</span>
            ${photosHtml}
        </div>
        `;
    }

    static backgroundScrollViewHtml() {
        setTimeout(() => {
            ImportModal.backgroundScrollViewListeners();
        }, 50);
        return `
        <div style="overflow: hidden;height:90%;width:100%" id="backgroundScrollView" style="text-align:center;">
            <div id="innerScrollContainer" style="position:absolute${ImportModal.HtmlImage === null ? ';display:none' : ''}" data-drop="true">
                <canvas id="backgroundImage" draggable="false" />
            </div>
            <canvas id="zoomLens" draggable="false"
             style="position:absolute;width:200px;height:200px;top:0;left:0;display:none;z-index:1001;" />
        </div>
        `;
    }

    static markersHtml() {
        setTimeout(() => {
            ImportModal.markersListeners();
        }, 50);

        return `
        <div class="vertical-container" id="markers" data-drop="true">
            <div>Placez les marqueurs</div>
            <div class="lateral-container" style="justify-content:space-between;padding:0 20px 0 20px;z-index:500;">
                <img id="markerA" style="width:60px;z-index:100;${ImportModal.HtmlImage === null && 'display:none'}" 
                    src="${ImportModal.POINTER_IMG}"data-drag="true" ng-model="markA"/>
                <img id="markerB" style="width:60px;z-index:100;${ImportModal.HtmlImage === null && 'display:none'}" 
                    src="${ImportModal.POINTER_IMG}" data-drag="true" ng-model="markB"/>

                <img style="width:60px;z-index:1000;cursor:not-allowed;${ImportModal.HtmlImage !== null && 'display:none'}" src="${ImportModal.POINTER_IMG}"/>
                <img style="width:60px;z-index:1000;cursor:not-allowed;${ImportModal.HtmlImage !== null && 'display:none'}" src="${ImportModal.POINTER_IMG}"/>
            </div>
        </div>
        `;
    }

    static buttonsPanelHtml() {
        setTimeout(() => {
            ImportModal.buttonsPanelListeners();
        }, 50);

        return `
        <div class="col-xs-3 lateral-container" id="buttonsPanel" style="height:100%;padding-top:30px;width:350px" data-drop="true">
            <a href="javascript:void(0)" id="leftArrowButton" title="Page précédente" style="left:2%;top:50%;" class="flip" 
            ${ImportModal.pdf === null || ImportModal.pdf._pdfInfo.numPages <= 1 ? 'disabled="disabled"' : ''}>
                <i class="material-icons icon-ArrowMiniRight"></i> 
            </a>

            <a href="javascript:void(0)" id="rotateLeft10" class="btn btn-link" 
                ${ImportModal.HtmlImage === null && 'disabled="disabled"'}>
                <i class="material-icons icon-FloatBar_Undo" style="font-size:75%;"></i>
            </a>
            <div class="horizontal-separator" style="height:25px;margin-left:4px;"></div>
            <a href="javascript:void(0)" class="btn btn-link" id="rotateLeft" 
                ${ImportModal.HtmlImage === null && 'disabled="disabled"'}>
                <i class="material-icons icon-RotateLeft" style="font-size:200%;"></i>
            </a>
            <div class="horizontal-separator"style="height:25px;margin-left:4px;"></div>
            <a href="javascript:void(0)" id="rotateRight" class="btn btn-link pull-right" 
                ${ImportModal.HtmlImage === null && 'disabled="disabled"'}>
                <i class="material-icons icon-RotateRight" style="font-size:200%;"></i>
            </a>
            <div class="horizontal-separator" style="height:25px;margin-left:4px;"></div>
            <a href="javascript:void(0)" id="rotateRight10" class="btn btn-link pull-right" 
                ${ImportModal.HtmlImage === null && 'disabled="disabled"'}>
                <i class="material-icons icon-FloatBar_Redo" style="font-size:75%;"></i>
            </a>
            <div class="horizontal-separator" style="height:25px;margin-left:4px;"></div>
            <a href="javascript:void(0)" id="flip" class="btn btn-link" 
                ${ImportModal.HtmlImage === null && 'disabled="disabled"'}>
                <i class="material-icons icon-Refresh" style="font-size:200%;"></i>
            </a>

            <a href="javascript:void(0)" id="rightArrowButton" title="Page suivante" style="right:2%;top:50%;"
                ${ImportModal.pdf === null || ImportModal.pdf._pdfInfo.numPages <= 1 ? 'disabled="disabled"' : ''}>
                <i class="material-icons icon-ArrowMiniRight"></i>
            </a>
        </div>
        `;
    }

    static planButtonsHtml() {
        return `
        <div class="importPlanBottom lateral-container" id="planButtons"
            style="text-align:center;height:10%;width:100%;justify-content:center;">

            <div id="markersContainer" style='display:contents'>
                ${ImportModal.markersHtml()}
            </div>

            <div id="buttonsPanelContainer" style='display:contents'>
                ${ImportModal.buttonsPanelHtml()}
            </div>
        </div>
        `;
    }

    static stageTwoHtml() {
        return `
        <div class="col-xs-12">
            <h3 style="font-weight:700;margin-top:10px;">Étape 2</h3>
            <p style="margin-bottom:10px;">
            Positionnez les deux marqueurs sur votre plan à partir d'une cote réelle.
            </p>
            <div class="lateral-container" style="width:100%;">
                <img style="width:95%;max-width:200px;" src="${ImportModal.TUTO_POINTER_IMG}" style="margin-bottom:25px;" />
            </div>
        </div>
        `;
    }

    static stageThreeHtml() {
        return `
        <div class="col-xs-12">
            <h3 style="font-weight:700;margin-top:10px;">Étape 3</h3>
            <p style="margin-bottom:10px;">
                Indiquez précisément la distance réelle entre ces 2 points.
            </p>
            <div class="form-group col-xs-12">
                <label for="inputPlanScale" class="control-label">Distance réelle</label>
                <i class="unit" style="left:130px;">cm</i>
                <input id="inputPlanScale" type="text" class="form-control" type="number" step="1"
                    style="width:150px;" ng-model="inputPlanModel" />
            </div>
        </div>
        `;
    }

    static stageThreeBisHtml() {
        setTimeout(() => {
            ImportModal.stageThreeBisListeners();
        }, 50);

        return `
        <div class="col-xs-12" ${!ImportModal.isDesigner ? 'style="display: none;"' : ''}>
            <p style="margin-bottom:10px;">ou</p>
            <div class="form-group col-xs-12">
                ${ImportModal.paperFormatHtml()}
            </div>
            <div class="form-group col-xs-12">
                ${ImportModal.paperScaleHtml()}
            </div>
        </div>
        `;
    }

    static paperScaleHtml() {
        let childrenHtml = `<option value="?" ${ImportModal.paperScale === null && 'selected="selected"'}></option>`;
        ImportModal.paperScales.forEach((paperScale) => {
            childrenHtml += `<option value="number:${paperScale.id}" label="${paperScale.name}" ${ImportModal.paperScale && ImportModal.paperScale.id === paperScale.id && 'selected="selected"'}">${paperScale.name}</option>`;
        });

        return `
            <label for="paperScale" class="control-label">Échelle</label>
            <select id="paperScale" class="form-control" style="width:150px;">
                ${childrenHtml}
            </select>
        `;
    }

    static paperFormatHtml() {
        let childrenHtml = `<option value="?" ${ImportModal.paperFormat === null && 'selected="selected"'}></option>`;
        ImportModal.paperFormats.forEach((paperFormat) => {
            childrenHtml += `<option value="number:${paperFormat.id}" label="${paperFormat.name}" ${ImportModal.paperFormat && ImportModal.paperFormat.id === paperFormat.id && 'selected="selected"'}>${paperFormat.name}</option>`;
        });

        return `
            <label for="paperFormat" class="control-label">Format</label>
            <select id="paperFormat" class="form-control" style="width:150px;">
                ${childrenHtml}
            </select>
        `;
    }

    static modalHeader() {
        return `
        <div class="modal-header">
            <button id="importmodalcloser" type="button" class="close" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
            <h5 class="modal-title">Importer un plan</h5>
        </div>
        `;
    }

    static modalContent() {
        setTimeout(() => {
            ImportModal.controller.addEventListener('click', ImportModal.validate, 'validateBtn', undefined, true);
        }, 50);
        return `
        <div class="creation-body" style="width:100%;padding-top:0;margin-bottom:0px;height:100%;">
            <div style="display:contents" id="fileInfo">
                ${ImportModal.fileInfoHtml()}
            </div>

            <div class="lateral-container" style="width:100%;height:100%;">
                <div class="vertical-container" style="position:relative;overflow: hidden;width:85%;height:100%;padding-bottom:0px;">
                    <div style="display:contents" id="planChoiceButton">    
                        ${ImportModal.planChoiceButtonHtml()}
                    </div>
                    <div style="display:contents" id="planChoiceProject">  
                        ${ImportModal.planChoiceProjectHtml()}
                    </div>

                    ${ImportModal.backgroundScrollViewHtml()}

                    ${ImportModal.planButtonsHtml()}
                </div>

                <div id="lateralColumnImport" class="help-lateral vertical-container"
                    style="width:15%;height:100%;padding-bottom:0px;">

                    ${ImportModal.stageTwoHtml()}

                    <div id="stageThreeContainer">
                        ${ImportModal.stageThreeHtml()}
                    </div>
                    ${ImportModal.stageThreeBisHtml()}

                    <button class="btn btn-primary btn-lg" id="validateBtn">
                        Valider<i class="material-icons icon-AnnulerActive"></i>
                    </button>
                </div>
            </div>
        </div>
        `;
    }

    static modal() {
        var html = `
            <div class="modal-dialog modal-lg" style="width:93vw;min-width:800px;margin-top: 0px;margin-bottom: 0px;">
                <div class="modal-content">
                    ${ImportModal.modalHeader()}
                    <div id="planPopUpBody" class="modal-body" style="height:94vh;min-height:600px;padding:0 0 0 0;overflow:hidden;">
                        ${ImportModal.modalContent()}
                    </div>
                </div>
            </div>
        `;

        var modalContainer = document.createElement('div');
        modalContainer.className = 'modal fade';
        modalContainer.tabIndex = -1;
        modalContainer.role = "dialog";
        modalContainer.ariaLabel = "importModal";
        modalContainer.id = "importModal";
        modalContainer.innerHTML = html;
        return modalContainer;
    }

    //#endregion
}